import React, { useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "./Navbar";
import { TodoContext } from "./Todo_Context";
import "../index.css";

export default function Notes() {
  const { deleteTodo, deletedItems } = useContext(TodoContext);
  return (
    <div id="notes" className="notes">
      <Navbar />

      {deletedItems.map((todo) => (
        <div key={todo.id} className="p-1 bg-light text-styles card-text">
          <p className={`${todo.isBold ? "bold" : ""} ${todo.isItalic?"italic":""} p-text`}>{todo.text}</p>

          <button
            className="btn btn-danger m-1"
            onClick={() => deleteTodo(todo.id)}
          >
            Delete
          </button>
        </div>
      ))}
    </div>
  );
}
